const API_ROOT = process.env.REACT_APP_BASE_URL || "";

export async function converse(prompt) {
  const token = localStorage.getItem("access_token");

  const res = await fetch(`${API_ROOT}/api/converse/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify({ prompt }),
  });

  if (!res.ok) throw new Error("Network response was not ok");
  return await res.json();
}

